/* Organic traffic already knows what the product is — it arrived from the
   video. The full-height hero made that visitor scroll to reach the thing they
   came for, and its two CTAs only jumped 100px down the page. So: shrink the
   hero hard and drop the buttons, leaving the top of the buy box visible above
   the fold on mobile. The joke still lands; the price arrives almost at once. */
(function(){
function build(){
var cd=document.getElementById('cd');
if(!cd)return;
var hero=cd.querySelector('section');
if(!hero||hero.getAttribute('data-cd-short'))return;
hero.setAttribute('data-cd-short','1');

hero.style.minHeight='0';
hero.style.height='auto';

var inner=hero.children[hero.children.length-1];
if(inner){inner.style.padding='clamp(26px,7vw,44px) 20px clamp(24px,6vw,40px)';}

var h1=hero.querySelector('h1');
if(h1){h1.style.fontSize='clamp(30px,8vw,52px)';h1.style.margin='0 0 12px';}

var badge=hero.querySelector('span');
if(badge){badge.style.marginBottom='12px';}

var p=hero.querySelector('p');
if(p){p.style.fontSize='clamp(14px,3.2vw,17px)';p.style.margin='0 auto 0';p.style.maxWidth='520px';}

/* the CTAs pointed at a section immediately below — pure friction */
var ctaRow=inner?inner.querySelector('div'):null;
if(ctaRow&&ctaRow.querySelector('a')){ctaRow.style.display='none';}
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build);}else{build();}
setTimeout(build,250);
})();
